const BaseMissingInterpolatedValuesHandler = require('./BaseMissingInterpolatedValuesHandler')

module.exports = class RaiseErrorOnMissingInterpolatedValuesHandler extends BaseMissingInterpolatedValuesHandler {
  handleMissingInterpolatedValue(message, value) {
    throw new Error(
      `I18n Formatter: The value {${value}} required by message "${message}" was not supplied.`
    )
  }
}
